import { ISiteSettingsForServerAdmin } from '../../../settings/types/ISite';
import { IResult } from '../../../httpClient/serverApi/types/IResponse';
import { Request } from '../../../httpClient/serverApi/requests/Request';

export interface IGetSiteSettingsForServerAdminParams {
  id: string;
}

export type IGetSiteSettingsForServerAdminResult = IResult & ISiteSettingsForServerAdmin;

export class GetSiteSettingsForServerAdminRequest
  extends Request<IGetSiteSettingsForServerAdminParams, IGetSiteSettingsForServerAdminResult>
{
  constructor(params: IGetSiteSettingsForServerAdminParams) {
    super('getSiteSettingsForServerAdmin', params);
  }
}
